export const productionTypeData = [
  "Order Wise",
  "Item Wise",
  "Production Line Wise",
];

export const productionDetailsTypeData = [
  "Total Item",
  "Total Qty",
  "Pending Item",
  "Pending Qty",
];

export const ProductionDetailsStatus = {
  "Order Wise": [
    { status: "Total Items", label: "Total Items", countKey: "5" },
    { status: "Total Qty", label: "Total Qty", countKey: "7" },
    {
      status: "Pending Items",
      label: "Pending Items",
      countKey: "2",
    },
    { status: "Pending Qty", label: "Pending Qty", countKey: "5" },
    {
      status: "Completed Items",
      label: "Completed Items",
      countKey: "2",
    },
    { status: "Completed Qty", label: "Completed Qty", countKey: "5" },
  ],
  "Machine Wise": [
    { status: "Total Items", label: "Total Items", countKey: "2" },
    { status: "Total Qty", label: "Total Qty", countKey: "6" },
    {
      status: "Pending Items",
      label: "Pending Items",
      countKey: "2",
    },
    { status: "Pending Qty", label: "Pending Qty", countKey: "2" },
    {
      status: "Completed Items",
      label: "Completed Items",
      countKey: "2",
    },
    { status: "Completed Qty", label: "Completed Qty", countKey: "5" },
  ],
};

export const timeAgo = (isoString) => {
  const diff = Math.floor((Date.now() - new Date(isoString)) / 1000);
  if (diff < 60) return `${diff}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  const h = Math.floor(diff / 3600);
  const m = Math.floor((diff % 3600) / 60);
  if (diff < 86400) return `${h}h ${m}m ago`;
  const days = Math.floor(diff / 86400);
  return `${days}d ${h % 24}h ${m}m ago`;
};

// ─── Dummy Data ───────────────────────────────────────────────────────────────
const now = new Date();
const daysAgo = (d) => new Date(now - d * 24 * 60 * 60 * 1000);
const hoursAgo = (h) => new Date(now - h * 3600000).toISOString();

export const ORDER_WISE_DUMMY = [
  {
    id: "o1",
    queueNo: 1,
    voucherNo: "PV-2026-001",
    createdAt: daysAgo(2),
    updatedAt: hoursAgo(5),
    customer: "Satyam Singh / Sing Interior",
    totalItems: 8,
    pendingItems: 6,
    totalQty: 850,
    pendingQty: 790,
    producedQty: 60,
    warehouse: "Nadarganj",
    machine: "Extruder 2",
    status: "In Production",
    qtyHistory: [{ qty: 60, note: "", ts: hoursAgo(5) }],
    priority: "Urgent",
  },
  {
    id: "o2",
    queueNo: 2,
    voucherNo: "PV-2026-002",
    createdAt: daysAgo(3),
    updatedAt: hoursAgo(10),
    customer: "Ravi Kumar / RK Traders",
    totalItems: 5,
    pendingItems: 3,
    totalQty: 400,
    pendingQty: 200,
    producedQty: 200,
    warehouse: "Alambagh",
    machine: "Extruder 1",
    status: "In Production",
    qtyHistory: [
      { qty: 100, note: "", ts: daysAgo(1) },
      { qty: 100, note: "", ts: hoursAgo(10) },
    ],
    priority: "Normal",
  },
  {
    id: "o3",
    queueNo: 3,
    voucherNo: "PV-2026-003",
    createdAt: daysAgo(5),
    updatedAt: hoursAgo(2),
    customer: "Meena Patel / Patel Decor",
    totalItems: 6,
    pendingItems: 0,
    totalQty: 600,
    pendingQty: 0,
    producedQty: 600,
    warehouse: "Nadarganj",
    machine: "Extruder 3",
    status: "Ready For Dispatch",
    qtyHistory: [
      { qty: 200, note: "", ts: daysAgo(3) },
      { qty: 200, note: "", ts: daysAgo(2) },
      { qty: 200, note: "", ts: hoursAgo(2) },
    ],
    priority: "Normal",
  },
  {
    id: "o4",
    queueNo: 4,
    voucherNo: "PV-2026-004",
    createdAt: daysAgo(1),
    updatedAt: hoursAgo(20),
    customer: "Arjun Das / Das Interiors",
    totalItems: 4,
    pendingItems: 4,
    totalQty: 300,
    pendingQty: 300,
    producedQty: 0,
    warehouse: "Gomti Nagar",
    machine: "Extruder 2",
    status: "Voucher",
    qtyHistory: [],
    priority: "Urgent",
  },
  {
    id: "o5",
    queueNo: 5,
    voucherNo: "PV-2026-005",
    createdAt: daysAgo(4),
    updatedAt: hoursAgo(8),
    customer: "Sunita Sharma / SS Homes",
    totalItems: 7,
    pendingItems: 5,
    totalQty: 500,
    pendingQty: 350,
    producedQty: 150,
    warehouse: "Alambagh",
    machine: "Extruder 1",
    status: "In Production",
    qtyHistory: [{ qty: 150, note: "", ts: hoursAgo(8) }],
    priority: "Normal",
  },
  {
    id: "O6",
    queueNo: 6,
    voucherNo: "PV-2026-005",
    createdAt: daysAgo(4),
    updatedAt: hoursAgo(8),
    customer: "Sunita Sharma / SS Homes",
    totalItems: 7,
    pendingItems: 0,
    totalQty: 500,
    pendingQty: 0,
    producedQty: 500,
    warehouse: "Nahariya",
    machine: "Extruder 8",
    status: "Dispatched",
    qtyHistory: [
      { qty: 150, note: "", ts: hoursAgo(8) },
      { qty: 50, note: "", ts: hoursAgo(9) },
      { qty: 150, note: "", ts: hoursAgo(9) },
      { qty: 150, note: "", ts: hoursAgo(9) },

    ],
    priority: "Urgent",
  },
];

export const ITEM_WISE_DUMMY = [
  {
    id: "i1",
    queueNo: 1,
    orderId: "ORD-1081",
    createdAt: daysAgo(2),
    updatedAt: hoursAgo(5),
    customer: "Satyam Singh / Sing Interior",
    collection: "SUPER HEAVY",
    itemCode: "SHD11",
    requiredQty: 100,
    producedQty: 60,
    pendingQty: 40,
    warehouse: "Alambagh",
    machine: "Extruder 2",
    status: "In Production",
    qtyHistory: [{ qty: 60, note: "", ts: hoursAgo(5) }],
  },
  {
    id: "i2",
    queueNo: 2,
    orderId: "ORD-1081",
    createdAt: daysAgo(2),
    updatedAt: hoursAgo(10),
    customer: "Satyam Singh / Sing Interior",
    collection: "SUPER HEAVY",
    itemCode: "SHF1B",
    requiredQty: 100,
    producedQty: 0,
    pendingQty: 100,
    warehouse: "Alambagh",
    machine: "Extruder 2",
    status: "In Production",
    qtyHistory: [],
  },
  {
    id: "i3",
    queueNo: 3,
    orderId: "ORD-1081",
    createdAt: daysAgo(2),
    updatedAt: hoursAgo(5),
    customer: "Satyam Singh / Sing Interior",
    collection: "SUPER HEAVY",
    itemCode: "SHF6",
    requiredQty: 100,
    producedQty: 0,
    warehouse: "Alambagh",
    pendingQty: 100,
    machine: "Extruder 2",
    status: "In Production",
    qtyHistory: [],
  },
  {
    id: "i4",
    queueNo: 4,
    orderId: "ORD-1074",
    createdAt: daysAgo(3),
    updatedAt: hoursAgo(6),
    customer: "Ravi Kumar / RK Traders",
    collection: "HARD ROCK",
    itemCode: "HRF22",
    requiredQty: 80,
    producedQty: 40,
    warehouse: "Alambagh",
    pendingQty: 40,
    machine: "Extruder 1",
    status: "In Production",
    qtyHistory: [{ qty: 40, note: "", ts: hoursAgo(10) }],
  },
  {
    id: "i5",
    queueNo: 5,
    orderId: "ORD-1074",
    createdAt: daysAgo(3),
    updatedAt: hoursAgo(8),
    customer: "Ravi Kumar / RK Traders",
    collection: "HARD ROCK",
    itemCode: "HRK14",
    requiredQty: 120,
    producedQty: 0,
    pendingQty: 120,
    warehouse: "Alambagh",
    machine: "Extruder 1",
    status: "In Production",
    qtyHistory: [],
  },
  {
    id: "i6",
    queueNo: 6,
    orderId: "ORD-1067",
    createdAt: daysAgo(5),
    updatedAt: hoursAgo(3),
    customer: "Meena Patel / Patel Decor",
    collection: "—",
    itemCode: "PLN07",
    requiredQty: 150,
    producedQty: 150,
    pendingQty: 0,
    warehouse: "Kaiserbagh",
    machine: "Extruder 3",
    status: "Ready For Dispatch",
    qtyHistory: [
      { qty: 50, note: "", ts: daysAgo(3) },
      { qty: 100, note: "", ts: hoursAgo(2) },
    ],
  },
];

export const MACHINE_WISE_DUMMY = [
  {
    id: "m1",
    queueNo: 1,
    machine: "Extruder 1",
    orderId: "ORD-1074",
    createdAt: daysAgo(3),
    updatedAt: hoursAgo(2),
    customer: "Ravi Kumar / RK Traders",
    collection: "HARD ROCK",
    itemCode: "HRF22",
    requiredQty: 900,
    producedQty: 350,
    pendingQty: 550,
    warehouse: "Kaiserbagh",

    status: "In Production",
    utilization: 72,
    qtyHistory: [{ qty: 350, note: "", ts: hoursAgo(6) }],
  },
  {
    id: "m2",
    queueNo: 2,
    machine: "Extruder 2",
    orderId: "ORD-1081",
    createdAt: daysAgo(2),
    updatedAt: hoursAgo(3),
    customer: "Satyam Singh / Sing Interior",
    collection: "SUPER HEAVY",
    itemCode: "SHD11",
    requiredQty: 850,
    producedQty: 60,
    warehouse: "Kaiserbagh",

    pendingQty: 790,
    status: "In Production",
    utilization: 45,
    qtyHistory: [{ qty: 60, note: "", ts: hoursAgo(5) }],
  },
  {
    id: "m3",
    queueNo: 3,
    machine: "Extruder 3",
    orderId: "ORD-1067",
    createdAt: daysAgo(5),
    updatedAt: hoursAgo(4),
    customer: "Meena Patel / Patel Decor",
    collection: "—",
    itemCode: "PLN07",
    requiredQty: 600,
    producedQty: 600,
    pendingQty: 0,
    warehouse: "Kaiserbagh",

    status: "Ready For Dispatch",
    utilization: 100,
    qtyHistory: [{ qty: 600, note: "", ts: hoursAgo(2) }],
  },
  {
    id: "m4",
    queueNo: 4,
    machine: "Extruder 4",
    orderId: "—",
    createdAt: daysAgo(1),
    updatedAt: hoursAgo(7),
    customer: "Unassigned",
    collection: "—",
    itemCode: "—",
    requiredQty: 0,
    producedQty: 0,
    pendingQty: 0,
    warehouse: "Kaiserbagh",

    status: "Voucher",
    utilization: 0,
    qtyHistory: [],
  },
  {
    id: "m5",
    queueNo: 5,
    machine: "Loom A",
    orderId: "ORD-1059",
    createdAt: daysAgo(1),
    updatedAt: hoursAgo(4),
    customer: "Arjun Das / Das Interiors",
    collection: "SUPER HEAVY",
    itemCode: "SHK20",
    requiredQty: 400,
    producedQty: 100,
    pendingQty: 300,
    warehouse: "Kaiserbagh",

    status: "In Production",
    utilization: 30,
    qtyHistory: [{ qty: 100, note: "", ts: hoursAgo(8) }],
  },
];

// ─── Per-tab column definitions ───────────────────────────────────────────────
export const ORDER_WISE_COLUMNS = [
  { key: "voucherNo_Date", label: "Voucher & Date & Time" },
  // { key: "createdAt", label: "Date & Time" },
  { key: "customer", label: "Customer" },
  { key: "priority", label: "Priority" },

  { key: "totalItems", label: "Items" },
  { key: "pendingItems", label: "Pending Items" },
  { key: "totalQty", label: "Quantity" },
  { key: "pendingQty", label: "Pending Qty" },
  { key: "warehouse", label: "Warehouse" },
  { key: "progress", label: "Progress" },
  { key: "status", label: "Status" },
  { key: "updatedAt", label: "Last Action" },
  { key: "action", label: "" },
];

export const ITEM_WISE_COLUMNS = [
  { key: "orderId_date", label: "Voucher & Date & Time" },
  { key: "customer", label: "Customer" },
  { key: "collection", label: "Collection" },
  { key: "itemCode", label: "Items" },
  { key: "requiredQty", label: "Required Qty" },
  { key: "producedQty", label: "Produced Qty" },
  { key: "pendingQty", label: "Pending Qty" },
  { key: "machine", label: "Production Line" },
  { key: "warehouse", label: "Warehouse" },
  { key: "progress", label: "Progress" },
  { key: "status", label: "Status" },
  { key: "updatedAt", label: "Last Action" },
  { key: "action", label: "" },
];

export const MACHINE_WISE_COLUMNS = [
  { key: "machine", label: "Production Line" },
  { key: "itemCode", label: "Items" },
  { key: "warehouse", label: "Warehouse" },
  { key: "orderId_date", label: "Voucher & Date & Time" },
  { key: "customer", label: "Customer" },
  { key: "collection", label: "Collection" },
  { key: "requiredQty", label: "Required Qty" },
  { key: "producedQty", label: "Produced Qty" },
  { key: "pendingQty", label: "Pending Qty" },
  { key: "progress", label: "Progress" },
  { key: "status", label: "Status" },
  { key: "updatedAt", label: "Last Action" },
  { key: "action", label: "" },
];

// ─── Grid templates per tab (Queue + columns) ─────────────────────────────────
export const TAB_GRIDS = {
  "Order Wise":
    "0.5fr 1.5fr 1.5fr 1fr 0.6fr 0.7fr 0.7fr  0.7fr 0.7fr 1.3fr 1.3fr 0.7fr 0.3fr",
  // "Item Wise":
  // "0.5fr 1.5fr 1.4fr 1fr 0.9fr 0.7fr 0.7fr 0.7fr 0.9fr 1.1fr 0.9fr 0.5fr",
  "Item Wise":
    "0.5fr 1.5fr 1.4fr 1fr 0.9fr 0.7fr 0.7fr 0.7fr 0.9fr 0.9fr 1.3fr 1.3fr 1fr 0.3fr",
  // "Production Line Wise":
  //   "0.5fr 1fr 1.5fr 1.4fr 1fr 0.9fr 0.7fr 0.7fr 0.7fr 1.1fr 0.9fr 0.5fr",
  "Production Line Wise":
    "0.5fr 0.8fr 0.7fr 1fr 1.4fr 1.3fr 0.9fr 0.7fr  0.7fr 0.7fr  1.3fr 1.3fr 1fr 0.3fr",
};

export const TAB_COLUMNS = {
  "Order Wise": ORDER_WISE_COLUMNS,
  "Item Wise": ITEM_WISE_COLUMNS,
  "Production Line Wise": MACHINE_WISE_COLUMNS,
};

// ─── Status cards config per tab ─────────────────────────────────────────────
export const TAB_STATUS_CONFIG = {
  "Order Wise": [
    { status: "Voucher", label: "Voucher", countKey: "voucher" },
    {
      status: "In Production",
      label: "In Production",
      countKey: "inProduction",
    },
    {
      status: "Ready For Dispatch",
      label: "Ready For Dispatch",
      countKey: "readyForDispatch",
    },
    { status: "Dispatched", label: "Dispatched", countKey: "dispatched" },
    { status: "Cancelled", label: "Cancelled", countKey: "cancelled" },
  ],
  "Item Wise": [
    { status: "Voucher", label: "Voucher", countKey: "voucher" },
    {
      status: "In Production",
      label: "In Production",
      countKey: "inProduction",
    },
    {
      status: "Ready For Dispatch",
      label: "Ready For Dispatch",
      countKey: "readyForDispatch",
    },
    { status: "Dispatched", label: "Dispatched", countKey: "dispatched" },

    { status: "Cancelled", label: "Cancelled", countKey: "cancelled" },
  ],
  "Production Line Wise": [
    { status: "Voucher", label: "Idle", countKey: "voucher" },
    { status: "In Production", label: "Running", countKey: "inProduction" },
    {
      status: "Ready For Dispatch",
      label: "Job Complete",
      countKey: "readyForDispatch",
    },
    { status: "Dispatched", label: "Dispatched", countKey: "dispatched" },

    { status: "Cancelled", label: "Offline", countKey: "cancelled" },
  ],
};

export const TAB_STATUS_COUNTS = {
  "Order Wise": [
    { count: 1, prevCount: 6, amount: 42000 },
    { count: 3, prevCount: 10, amount: 85000 },
    { count: 1, prevCount: 3, amount: 18000 },
    { count: 1, prevCount: 3, amount: 18000 },

    { count: 0, prevCount: 2, amount: 9000 },
  ],
  "Item Wise": [
    { count: 0, prevCount: 15, amount: 120000 },
    { count: 5, prevCount: 10, amount: 85000 },
    { count: 1, prevCount: 7, amount: 42000 },
    { count: 0, prevCount: 3, amount: 12000 },
    { count: 0, prevCount: 3, amount: 12000 },
  ],
  "Production Line Wise": [
    { count: 1, prevCount: 2, amount: 0 },
    { count: 3, prevCount: 3, amount: 0 },
    { count: 1, prevCount: 1, amount: 0 },
    { count: 0, prevCount: 0, amount: 0 },
    { count: 0, prevCount: 3, amount: 0 },
  ],
};

export const warehousesData = [
  { _id: "1", warehousename: "Burlington", warehouseId: "BLTON01" },
  { _id: "2", warehousename: "Golaganj", warehouseId: "GOGNJ01" },
  { _id: "3", warehousename: "Nadarganj", warehouseId: "NDGNJ01" },
  { _id: "4", warehousename: "Alambagh", warehouseId: "ALAMB0001" },
  { _id: "5", warehousename: "Gomti Nagar", warehouseId: "GOMTI001" },
];

export const machinesData = [
  { _id: "1", machineName: "Extruder 1", machineId: "EXT1" },
  { _id: "2", machineName: "Extruder 2", machineId: "EXT2" },
  { _id: "3", machineName: "Extruder 3", machineId: "EXT3" },
  { _id: "4", machineName: "Extruder 4", machineId: "EXT4" },
  { _id: "5", machineName: "Loom A", machineId: "LOOMA" },
];
